module.exports = __webpack_public_path__ + "static/media/NoResults.bef2a537.svg";